import {SearchPlaceholders} from "./utils/search-placeholder";
import {PopupManager} from "./utils/popupManager";

const mq = window.matchMedia('(max-width: 740px)');
const isMobile = mq.matches;
const isMobileWidth = $(window).width();
const MENU_HOVER_REST_DELAY = 100;
const MENU_HOVER_INTENT_SENSITIVITY = 7;

const checkoutPages = () => {
    let chooseShippingMethod = window.location.search.indexOf('cart/chooseShippingMethod') !== -1;
    let choosePaymentMethod = window.location.search.indexOf('cart/choosePaymentMethod') !== -1;
    let checkOrder = window.location.search.indexOf('cart/checkOrder') !== -1;

    return chooseShippingMethod || choosePaymentMethod || checkOrder;
};

const managingSearchBlock = () => {
    const mq = window.matchMedia('(max-width: 740px)');

    if (!(mq.matches && checkoutPages())) {
        $('.js_search-bar-form').addClass('visible');
    }
};

const manageSearchPlaceholder = () => {
    const $input = $('.js_search-input');

    if (! $input.length) return;

    const width = window.innerWidth;
    const selected = SearchPlaceholders.find(v => width < v.max);

    if (! selected) return;

    $input
        .removeClass('placeholder-small placeholder-large')
        .addClass(selected.class)
        .attr('placeholder', selected.text);
};

const changeMenuEmptyItemsLevelsMobile = () => {
    const $mainItem = $('.js_mobile-main-item');

    $mainItem.each((index, item) => {
        const $item = $(item);
        const itemData = $item.data();

        if (!itemData.children) {
            $item.find('.has-sub').addClass('reset-pseudo');
        }
    })
}

const menuAngle = () => {
    let arrayFirstLevelCoordinates = [];
    let currentCoordinateFirstLevel = {value:null};
    let arraySecondLevelCoordinates = [];
    let currentCoordinateSecondLevel = {value:null};
    let $mainNavigation = $('.mainNavigation');
    let $firstLevel = $mainNavigation.find('.mainItem > a');
    let $secondLevel = $mainNavigation.find('.mainItem > .level02 li a');
    const $menuLevelSection = $('.js_menu-level-section');

    addMenuEventListeners(arrayFirstLevelCoordinates, currentCoordinateFirstLevel, $firstLevel, currentCoordinateSecondLevel);
    addMenuEventListeners(arraySecondLevelCoordinates, currentCoordinateSecondLevel, $secondLevel);

    $('.foreground').mouseleave(()=> {
        setTimeout(()=>{
            $('.level02').siblings('div').removeClass('active-block');
            $('.mainItem > .has-sub').siblings('div').removeClass('active-block');
        },200);
    });

    attachMobileMenuEvents();
    attachAccessibleSubmenuEvents();

    $menuLevelSection.each((index, item) => {
        const $item = $(item);
        const childrenLength = $item.children().length;

        if (!childrenLength) {
            const closestItem = $item.closest('.menuHeaderBar');
            const closestSub = closestItem.closest('.mainItem').find('.has-sub');

            closestItem.remove();

            closestSub.parent().find('.level02').each((ind, level) => {
                const $level = $(level);

                if (!$level.children().length) {
                    $level.parent().find('.has-sub').addClass('reset-pseudo');
                }
            })
        }
    })

    $firstLevel.parent().each((index, item) => {
        const $item = $(item);

        if ($item.children().length < 2) {
            $item.find('.has-sub').addClass('reset-pseudo');
        }
    })

};

const changeMobileMenuDOM = (level, $element) => {
    const $mobileNav = $('.js-mobileNav');

    $mobileNav.find('.js-mobileNavBack').removeClass('is-disabled');

    if (level === 'level01') {
        $element.parent().addClass('is-active');
        $mobileNav.removeClass('is-level01');
        $mobileNav.addClass('is-level02');
    } else {
        $mobileNav.removeClass('is-level02');
        $mobileNav.addClass('is-level03');
    }

    $element.addClass('is-active');
    $mobileNav.find('.js-activeCategory').text($element.text());
};

const setMenuMaxHeight = () => {
    const $header = $('#header');

    setTimeout(() => {
        const headerVisibleHeight = $header.height() + $header.position().top;

        $('#accountMenuDropdown').css(isMobile ? 'height' : 'max-height', `calc(100vh - ${headerVisibleHeight}px)`);
    }, 0);
};

const attachMobileMenuEvents = () => {
    $('.mobileNav .mainItem a').click((event) => {
        const element = event.currentTarget;
        const $element = $(element);
        const li = element.parentElement;
        const ul = li.parentElement;
        const level = ul.parentElement;

        if (element.className === 'has-sub' && ['level01', 'level02'].includes(level.className)) {
            event.preventDefault();
            changeMobileMenuDOM(level.className, $element);
        }
    });

    changeMenuEmptyItemsLevelsMobile();
};

const attachAccessibleSubmenuEvents = () => {
    $(document).on('click', '[data-submenu-toggle]', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $button = $(this);
        const $level02 = $button.siblings('.level02');
        const isExpanded = $button.attr('aria-expanded') === 'true';

        if (isExpanded) {
            $button.attr('aria-expanded', 'false');
            $level02.removeClass('active-block');
        } else {
            // Close other submenus at same level first (only direct siblings)
            $button.closest('li').siblings('li').children('[data-submenu-toggle]').each(function() {
                $(this).attr('aria-expanded', 'false');
                $(this).siblings('.level02').removeClass('active-block');
            });

            $button.attr('aria-expanded', 'true');
            $level02.addClass('active-block');
        }
    });

    $(document).on('keydown', '[data-submenu-toggle]', function(e) {
        if (e.key === 'Escape') {
            const $button = $(this);
            $button.attr('aria-expanded', 'false');
            $button.siblings('.level02').removeClass('active-block');
            $button.focus();
        }
    });
};

const setHeaderHeight = () => {
    const $header = $('#header');

    if (isMobileWidth > 740) {
        $header.promise().then(() => {
            $header.css({top: window.headerBannerVisible ? '-3rem' : '-6rem'}, setMenuMaxHeight);
        });
    }
};

const hideHeaderAnimated = () => {
    const $header = $('#header');
    const screenLaptop = window.matchMedia('(max-width: 1024px)');

    $header.find('.slides.tns-slider').css('transition', 'none');
    $header.addClass('is-scrollingDown');
    $header.stop();

    if (!screenLaptop.matches) {
        $header.find('.usps').css('display', 'none');
    }

    if (isMobileWidth > 740) {
        $header.animate({top: window.headerBannerVisible ? '-3rem' : '-6rem'}, setMenuMaxHeight);

    }
};

const showHeaderAnimated = () => {
    const $header = $('header');
    const screenLaptop = window.matchMedia('(max-width: 1024px)');

    if (isMobileWidth > 740) {
        $('.desktop-float-buy-button .float-buy-button-container').promise().then(function () {
            $header.removeClass('is-scrollingDown');
            $header.stop();
            $header.animate({top: window.headerBannerVisible ? '3rem' : '0'}, setMenuMaxHeight);
            $header.find('.slides.tns-slider').css('transition', 'all 0s');
        });
    }

    if (!screenLaptop.matches) {
        $header.find('.usps').css('display', 'block');
    }
};

const isNeededSpecialMenuBehavior = () => {
    const isHomePage = $('.js_homepage-segments').length;

    if(isHomePage || isNewsletterLink()) {
        return true;
    }
};

const isNewsletterLink = () => {
    const searchQuery = window.location.search;
    const pathName = window.location.pathname;
    const isParamExist = (param) => searchQuery.indexOf(param) !== -1;
    const isPathSegmentExist = (segment) => pathName.indexOf(segment) !== -1;

    let utmSource = isParamExist('utm_source');
    let utmMedium = isParamExist('utm_medium');
    let utmCampaign = isParamExist('utm_campaign');
    let isSearch = isParamExist('action=search') || isParamExist('q') || searchQuery.includes('zoeken');
    let isDashboard = isPathSegmentExist('/dashboard');

    return utmSource && utmMedium && utmCampaign && !isSearch && !isDashboard;
};

const scrollHandler = () => {
    const $header = $('header');
    const headerH = $header ? $header.height() : 0;
    const screenBeforeSmall = window.matchMedia('(max-width: 740px)');
    const isHomePage = $('.js_homepage-segments').length;

    if (!$header.length || screenBeforeSmall.matches) {
        return false;
    }

    const mainNavBar = document.querySelector('.js-mainNavBar');
    const distanceY = window.pageYOffset || document.documentElement.scrollTop;
    const shrinkOn = headerH;

    if (distanceY > shrinkOn) {
        if ($header.hasClass('is-scrollingDown')) {
            setHeaderHeight();
        } else {
            hideHeaderAnimated();
        }

        if (isNeededSpecialMenuBehavior()) {
            $(mainNavBar).removeClass('is-active');
            $(mainNavBar).attr('inert', true);
            $('.js_menu-close').addClass('hidden');
            $('.js_menu-chevron').removeClass('hidden');
        }

    } else {
        if ($header.hasClass('is-scrollingDown')) {
            showHeaderAnimated();
        }

        if (isHomePage) {
            $(mainNavBar).addClass('is-active');
            $(mainNavBar).removeAttr('inert');
            $('.js_menu-close').removeClass('hidden');
            $('.js_menu-chevron').addClass('hidden');
        }
    }
};

const addMenuEventListeners = (arrayMouseCoordinates, currentCoordinate, $level, currentCoordinateSecondLevel) => {
    let timeoutId;
    let mouseMoveHandler;
    let lastPolledX, lastPolledY, latestX, latestY;

    const evaluateAndOpen = ($currentTarget, pageX, noChildInActiveBlock, allSubClosed) => {
        let currentCategory;

        if ($currentTarget.css('color') === 'rgb(255, 107, 0)') {
            currentCategory = true;
        }

        if ((-120 < pageX && 120 > pageX) || noChildInActiveBlock || allSubClosed || currentCategory) {
            if(!($('.mainItem > a:hover').length && !$currentTarget.parent().hasClass('mainItem')) && !$currentTarget.hasClass('menuLastLevel')) {
                $level.siblings('div').removeClass('active-block');
                $currentTarget.siblings('div').addClass('active-block');
            }
        }

        if ($currentTarget.parents().length < 20 && $currentTarget.hasClass('menuLastLevel')) {
            $level.siblings('div').removeClass('active-block');
        }
    };

    // hoverIntent-style polling (github.com/briancherne/jquery-hoverIntent): instead of
    // resetting a single timer on every mousemove (which never fires for a cursor that
    // drifts slowly but continuously), poll the latest tracked position every
    // MENU_HOVER_REST_DELAY ms and compare it to the position at the previous poll. Below
    // MENU_HOVER_INTENT_SENSITIVITY px of movement between polls counts as "at rest" and
    // opens the dropdown; otherwise keep polling.
    const pollForRest = ($currentTarget, pageX, noChildInActiveBlock, allSubClosed) => {
        const distance = Math.hypot(lastPolledX - latestX, lastPolledY - latestY);

        if (distance < MENU_HOVER_INTENT_SENSITIVITY) {
            evaluateAndOpen($currentTarget, pageX, noChildInActiveBlock, allSubClosed);
            return;
        }

        lastPolledX = latestX;
        lastPolledY = latestY;

        timeoutId = setTimeout(() => {
            pollForRest($currentTarget, pageX, noChildInActiveBlock, allSubClosed);
        }, MENU_HOVER_REST_DELAY);
    };

    $level.mouseenter((event) => {
        const $currentTarget = $(event.currentTarget);
        let pageX = event.pageX;
        let pageY = event.pageY;
        let noChildInActiveBlock = !currentCoordinateSecondLevel && !$('.level02 .active-block').length;
        let allSubClosed = !$level.siblings('div').hasClass('active-block');

        if (currentCoordinateSecondLevel) {
            currentCoordinateSecondLevel = {value:null};
            $currentTarget.parent().find('.level01 .level02').removeClass('active-block');
        }

        if (!currentCoordinate.value){
            $currentTarget.siblings('div').addClass('active-block');
            return
        }

        pageX = 180 * Math.atan2(currentCoordinate.value.y - pageY, currentCoordinate.value.x - pageX) / Math.PI;

        lastPolledX = event.pageX;
        lastPolledY = event.pageY;
        latestX = event.pageX;
        latestY = event.pageY;

        mouseMoveHandler = (a) => {
            latestX = a.pageX;
            latestY = a.pageY;

            arrayMouseCoordinates.push({
                x: a.pageX,
                y: a.pageY
            });
            10 < arrayMouseCoordinates.length && arrayMouseCoordinates.pop();
        };

        $currentTarget.on('mousemove', mouseMoveHandler);

        timeoutId = setTimeout(() => {
            pollForRest($currentTarget, pageX, noChildInActiveBlock, allSubClosed);
        }, MENU_HOVER_REST_DELAY);
    });

    $level.mouseleave((event)=> {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        $(event.currentTarget).off('mousemove', mouseMoveHandler);
        // Fall back to the mouseleave event's own point when no mousemove fired during
        // the hover (fast skimming across items). Leaving this undefined made the next
        // item's mouseenter take the !currentCoordinate.value fast path below and open
        // instantly, bypassing MENU_HOVER_REST_DELAY entirely.
        currentCoordinate.value = arrayMouseCoordinates[arrayMouseCoordinates.length - 1] || {x: event.pageX, y: event.pageY};
        arrayMouseCoordinates = [];
    });
};

const setHeaderSearchIcon = () => {
    const $hiddenSearchIcon = $('.hidden-search-icon');
    const $searchBar = $('.searchBar');
    const $breadcrumb = $('.breadcrumb');
    const isProductPage = window.isProductPage
    const isComparisonPage = document.querySelector(".js_comparison-page");
    const mq = window.matchMedia('(max-width: 740px)');

    if ((isProductPage || isComparisonPage) && mq.matches) {
        $hiddenSearchIcon.addClass('header-search-block');
        $breadcrumb.addClass('breadcrumbWithoutTop');
        $searchBar.addClass('hidden-search-icon').hide();
    }
}

const toggleHeaderSearch = () => {
    const $searchToggle = $('.js_search-toggle');
    const $searchBar = $('.searchBar');
    const $breadcrumb = $('.breadcrumb');
    const $searchInput = $searchBar.find('.js_search-input');

    $searchToggle.click(() => {
        $searchBar.show();
        $searchInput.focus();
        $breadcrumb.removeClass('breadcrumbWithoutTop');
        $breadcrumb.addClass('breadcrumbWithTop');
    })
}

const createAccountMobileView = () => {
    const isCreateAccountUrl = window.location.href.includes('/createAccount');
    const $searchBarContainer = $('.js_search-bar-container');
    const $downloadAppBar = $('.js_download-app-bar');
    const $checkoutContainer = $('.checkoutContainer');

    if (isCreateAccountUrl) {
        $searchBarContainer.addClass('hidden');
        $downloadAppBar.addClass('hidden');
        $checkoutContainer.addClass('resetMargin');
    }
}

const changeBodyTopOnSearch = () => {
    const $body = $('.js_body');
    const $appBanner = $('.js_download-app-bar');
    const isSearch = window.location.href.includes('zoeken');
    const isBreadCrumb = $('.breadcrumb').children().length;
    const isProductPage = window.isProductPage;

    if (isMobile) {
        if (isSearch) {
            $body.addClass($appBanner.hasClass('hidden') ? 'with-banner-search' : 'with-app-banner-search');
        }

        if (isBreadCrumb && !isProductPage) {
            $body.addClass('with-breadcrumbs');
        }

        if (!$appBanner.hasClass('hidden')) {
            $body.removeClass('with-banner-search');
        }
    }
};

const insertHeaderDependsOnScreenSize = () => {
    if ( isMobile ) {
        const mobileContainer = $('.js_mobile-menu-container')[0];
        const mobileTemplate = $('.js_mobile-menu-template')[0];
        const clonedMobileTemplate = mobileTemplate?.content?.cloneNode(true);

        clonedMobileTemplate && mobileContainer?.appendChild(clonedMobileTemplate);
    } else {
        const desktopContainer = $('.js_desktop-menu-container')[0];
        const desktopTemplate = $('.js_desktop-menu-template')[0];
        const clonedDesktopTemplate = desktopTemplate?.content?.cloneNode(true);

        clonedDesktopTemplate && desktopContainer?.append(clonedDesktopTemplate)
    }
};

const attachSearchButtonEvent = async () => {
    const isSearchPage = window.requestData;

    if(isSearchPage) {
        const {default: searchPages} = await import('./module/searchPages');
        searchPages.initPage();
    } else {
        $('.js_search-button').click(async (event) => {
            event.preventDefault();

            const $closestForm = $(event.target).parents('.js_search-bar-form');
            const $closestInput = $closestForm.find('.js_search-input');
            const isSearchPage = window.requestData;
            const searchValue = $closestInput.val().replace(/[\\|\/'"]/g, '-').trim();
            if (!searchValue || isSearchPage) {
                $closestInput.focus();
                return;
            }

            import ('./dataLayerEvents').then(({ dataLayerEvents }) => {
                dataLayerEvents.searchByKeyword({ search_term: searchValue });
            });

            window.location.href = `${window.env.baseUrl}/zoeken?q=${searchValue}`;
        });
    }
};

const accountControlOnClick = () => {
    const $accountMenu = $('.js_account-menu');

    if (!window.isLoggedUser) {
        window.location.href = `${window.env.baseUrl}/?action=auth/login`;
        return;
    }

    $('.js_account-header').toggleClass('is-active');
    $accountMenu.toggleClass('is-active');
    $('.js_overlay-show-account').toggleClass('is-active');

    if ($accountMenu.hasClass('is-active')) {
        setMenuMaxHeight();
    }
};

$(document).ready(() => {
    if (!('content' in document.createElement('template'))) return;

    initialize();

    function initialize() {
        insertHeaderDependsOnScreenSize();
        cacheElements();
        initialSetup();
        setupEventListeners();
        scrollHandler();
        manageSearchPlaceholder();
    }

    let $defaultTextContainer, $hamburgerMobile, $mainNavBar, $overlayMenu, $mobileNav, defaultText, $body;

    function cacheElements() {
        $defaultTextContainer = $('.js-activeCategory');
        $hamburgerMobile = $('.js-mobileNavToggle');
        $mainNavBar = $('.js-mainNavBar');
        $overlayMenu = $('.js_overlay-menu');
        $mobileNav = $('.js-mobileNav');
        $body = $('body');
        defaultText = $defaultTextContainer.data('defaulttext');
    }

    function initialSetup() {
        const navBarColor = $('navBar').css('color');
        if (navBarColor === 'rgb(0,0,0)') {
            $hamburgerMobile.addClass('hamburgerGrey');
        }

        $('.js_menu-close').addClass('hidden');
        $mainNavBar.attr('inert', true);
        $defaultTextContainer.text(defaultText);

        menuAngle();
        managingSearchBlock();
        toggleHeaderSearch();
        setHeaderSearchIcon();
        attachSearchButtonEvent();
        changeBodyTopOnSearch();

        if (isNeededSpecialMenuBehavior()) {
            adjustSpecialMenuBehavior();
        }
    }

    function setupEventListeners() {
        $('.js-mainNavBarToggle, .js_overlay-menu').click(toggleMainNavBar);

        $('.js-mobileNavToggle').click(() => {
            $body.toggleClass('js-showMobileNav');
        });

        $('.js-mobileNavBack').click(handleMobileNavBack);

        $(document).on('click', '.js_account-menu-close', toggleAccountMenu);

        $('.js_overlay-show-account').click(hideAccountOverlay);

        if (!isMobile) window.addEventListener('scroll', scrollHandler);

        if (window.location.search.includes('reset-password')) {
            hideMainNavBar();
        }

        if (isMobile) createAccountMobileView();

        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(manageSearchPlaceholder, 100);
        });
    }

    function showMainNavBar() {
        $mainNavBar.addClass('is-active');
        $mainNavBar.removeAttr('inert');
    }

    function hideMainNavBar() {
        $mainNavBar.removeClass('is-active');
        $mainNavBar.attr('inert', true);
    }

    function toggleMainNavBar() {
        if ($mainNavBar.hasClass('is-active')) {
            hideMainNavBar();
        } else {
            showMainNavBar();
        }

        $('.js_menu-close').toggleClass('hidden');
        $('.js_menu-chevron').toggleClass('hidden');

        if (!isNeededSpecialMenuBehavior()) {
            $overlayMenu.toggleClass('is-active');
        }

        $('.js_overlay-autocomplete').removeClass('is-active');
    }

    function handleMobileNavBack(event) {
        event.preventDefault();

        if ($mobileNav.hasClass('is-level02')) {
            $mobileNav.removeClass('is-level02').addClass('is-level01');
            $mobileNav.find('.js-mobileNavBack').addClass('is-disabled');
            $mobileNav.find('.js-activeCategory').text(defaultText);
            $mobileNav.find('.level01 a').removeClass('is-active');
        } else if ($mobileNav.hasClass('is-level03')) {
            $mobileNav.removeClass('is-level03').addClass('is-level02');
            $mobileNav.find('.js-activeCategory').text($mobileNav.find('.level01 ul li a.is-active:first').text());
            $mobileNav.find('.level02 a').removeClass('is-active');
        }
    }

    function toggleAccountMenu() {
        $('.js_account-header').toggleClass('is-active');
        $('.js_account-menu').toggleClass('is-active');
        $('.js_overlay-show-account').toggleClass('is-active');
    }

    function hideAccountOverlay() {
        $('.js_account-header, .js_account-menu').removeClass('is-active');
        $('.js_overlay-show-account').removeClass('is-active');
    }

    function adjustSpecialMenuBehavior() {
        $('header .bottomBar .containerFluid .mainNavigation .mainNavBar .background').css({ width: 0, height: 0 });
        $('.subNavigation-home, #overlayContainer .overlay.js_overlay-autocomplete').css('display', 'none');
    }
});

